import { useParams, useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { UserDetailBody } from '@/components/UserDetailBody';

export function UserDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  return (
    <div>
      <Button
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(-1)}
        style={{ marginBottom: 16 }}
        type="text"
      >
        목록으로
      </Button>

      <UserDetailBody userId={id!} onDeleted={() => navigate('/users')} />
    </div>
  );
}
